//@ts-check
import $ from 'jquery';
import Backbone from 'backbone';
import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import lscache from 'lscache';
import {search} from '@sinclair-digital/stl-common/src/sinclair/sinclair.media.utils';
import {hideTopLoader} from '@sinclair-digital/stl-common/src/sinclair/sinclair.ajax';
import {messageHandler} from '@sinclair-digital/stl-common/src/sinclair/sinclair.uiTools';
import {helpIconClicked} from 'analytics/help';
import BasePage from './nav/BasePage';
import {getVisibleModuleButtons} from 'modules';
import {destroy} from '@sinclair-digital/stl-common/src/backboneHelpers';

const ControllerView = Backbone.View.extend({
    el: '#app-main',
    debugModel: null,
    currentView: '',
    currentViewClass: '',
    initialize() {
        return this;
    },
    renderShell(userModel, appContext) {
        const debugModel = userModel.debugModel;
        const packageTypes = userModel.get('allowedPackageTypes');
        const templateData = {
            appContext,
            userModel,
            debugModel,
            user: userModel.toJSON().user,
            canViewWeather: packageTypes && packageTypes.includes('WEATHER'),
        };

        const menuItems = getVisibleModuleButtons(appContext, 'Nav');

        ReactDOM.render(
            <BasePage className="sda-ReactRoot" username={templateData.user.firstName} menuItems={menuItems} />,
            this.el,
        );
        this.bindMenuEvents();
        if (!packageTypes) {
            messageHandler('error', 'Failed to load user', 'Try logging out and back in.');
        }

        Backbone.history.start();
        return this;
    },
    bindMenuEvents() {
        // account dropdown menu
        $('.sda-header-menu-toggle').on('click', function() {
            const $this = $(this);
            const $menu = $this.closest('.sda-header-menu');
            const isOpen = $menu.hasClass('sda-header-menu-open');

            $('.sda-header-menu').removeClass('sda-header-menu-open');

            if (isOpen) {
                $menu.removeClass('sda-header-menu-open');
            } else {
                $menu.addClass('sda-header-menu-open');
                if ($this.is('.fa-question-circle')) {
                    helpIconClicked();
                }
            }
        });

        $('.sda-header-menu-options a').on('click', function() {
            $(this)
                .closest('.sda-header-menu')
                .removeClass('sda-header-menu-open');
        });

        $('#sda-sign-out, #sda-sign-out-mobile').on('click', function() {
            lscache.remove('userModel');
        });

        $('body').on('dragover drop', function(e) {
            e.preventDefault();
        });
        $('body').on('click', '.sda-nav-toggle', function() {
            $('.sda-nav-panel').toggleClass('panel-open');
        });
        $(document).on('click', function(e) {
            const $container = $('.sda-header-menu, .sda-view-menu');

            if (!$container.is(e.target) && $container.has(e.target).length === 0) {
                $container.removeClass('sda-header-menu-open sda-view-menu-open');
            }
        });
    },
    render(opts) {
        document.title = opts.title || 'Sinclair Storyline';
        hideTopLoader();

        // reset search global search queries on view render
        search.searchObj.query[0] = [];

        this.currentViewClass = opts.viewClass;

        if (this.currentView) {
            this.destroyView(this.currentView);
        }
        this.currentView = new opts.viewClass({
            ...opts,
            // Current Route Query Params
            queryParams: this._parseQueryParams(opts.queryParams),
        });

        if (this.currentView.hideHeader) {
            $('.sda-app-header').hide();
        } else {
            $('.sda-app-header').show();
        }

        this._setCurrentViewTab(this.currentView.navId);
        $('#sda-admin-header-view-title').html(opts.title || this.currentView.sdaPageTitle);

        return this;
    },
    _parseQueryParams(queryParams) {
        const params = {};

        if (_.isObject(queryParams)) {
            return queryParams;
        } else if (queryParams) {
            _.each(
                // decode each query parameter and attach it to the params object
                _.map(decodeURI(queryParams).split(/&/g), function(el) {
                    const aux = el.split('='),
                        o = {};

                    if (aux.length >= 1) {
                        let val = undefined;

                        if (aux.length === 2) {
                            val = aux[1];
                        }

                        o[aux[0]] = val;
                    }

                    return o;
                }),
                function(o) {
                    _.extend(params, o);
                },
            );
        }

        return params;
    },
    _buildDebugPanel() {},

    _setCurrentViewTab(id) {
        const $btns = $('.page-nav a');
        const $btn = $(`#${id}`);

        $btns.removeClass('active');
        $btn.addClass('active');
    },

    destroyView(view) {
        destroy(view);

        $('#admin-main').remove();
        $('.sda-nav-panel').after($('<main id="admin-main"></main>'));
    },
});

export default ControllerView;
